import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const competitionForm = document.getElementById("competition-form");

ReactDOM.render(
    <React.StrictMode>
        <App
            user={competitionForm.dataset.user}
            variant={competitionForm.dataset.variant}
            color={competitionForm.dataset.color}
            background={competitionForm.dataset.background}
            description={competitionForm.dataset.description}
            endPageContent={competitionForm.dataset.end}
            pageAfterQuestions={competitionForm.dataset.pageAfterQuestions}
            pageID={competitionForm.dataset.pageId}
        />
    </React.StrictMode>,
    competitionForm
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
